<template>
    <div>
        <v-list nav dense>
            <v-list-item-group color="primary">
                <v-list-item
                    link
                    v-for="(item, i) in details"
                    :key="i"
                    style="height: 25px; min-height: 25px; max-height: 25px;"
                    class="align-middle"
                    :href="item.file_url"
                    target="_blank"
                >
                    <v-list-item-icon style="margin-right: 15px; margin-top:0">
                        <v-icon color="info">link</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.file_type" style="font-size: 16px;"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </div>
</template>

<script>
export default {
    props: {
        details: {
            type: Array
        }
    }
};
</script>

<style lang="scss" scoped></style>
